module.exports = __webpack_public_path__ + "static/media/Eterno Fabric Left Arm Sofa.03cd3764.jpg";